import React from 'react'
import PropTypes from 'prop-types'
import { RoutedTabs, NavTab } from 'react-router-tabs'
import { isBrowser } from 'react-device-detect'
import { TimelineLite, TweenMax } from 'gsap'
import 'gsap/src/uncompressed/plugins/ScrollToPlugin'
import Heading from '../components/Heading'

class SubNavigation extends React.Component {
    constructor (props) {
        super(props)

        this.state = { expanded: false }
    }

    scrollToNav () {
        if (isBrowser) {
            TweenMax.to(window, 0.5, { scrollTo: { y: this.navContainer, offsetY: 60 } })
        } else {
		    this.hide()
            TweenMax.to(window, 0.5, { scrollTo: { y: this.navContainerMobile, offsetY: 35 } })
        }
    }

    toggleExpand (event) {
	    event.preventDefault()
        TweenMax.to(window, 0.5, { scrollTo: { y: this.navHeaderMobile, offsetY: 60 } })
        this.state.expanded ? this.contract() : this.expand()
    }

    expand () {
        const tl = new TimelineLite()
        TweenMax.set(this.hiddenContent, { height: 'auto', display: 'block' })
        tl.from(this.hiddenContent, 0.25, { height: 0 })
        tl.add(() => {
            this.setState({ expanded: true })
        })
    }

    contract () {
        const tl = new TimelineLite()
        tl.to(this.hiddenContent, 0.20, { height: '0' })
        tl.set(this.hiddenContent, { display: 'none', height: 'auto' })
        tl.add(() => {
            this.setState({ expanded: false })
        })
    }

    hide () {
        TweenMax.set(this.hiddenContent, { display: 'none', height: 'auto' })
        this.setState({ expanded: false })
    }

    render () {
	    const Tabs = (
            <RoutedTabs startPathWith={this.props.url} activeTabClassName='active'>
        {this.props.items.map((item, key) => {
                    return (
                        <NavTab
                            key={key}
                            to={item.url}
                            exact
                            onClick={this.scrollToNav.bind(this)}
                            dangerouslySetInnerHTML={{ __html: item.title }}
                            className={`nav-tab ${this.props.className ? this.props.className : ''}`}
                        />
                    )
                })}
    </RoutedTabs>
        )

	    const Desktop = (
            <div className='d-none d-sm-block'>
        <Heading title={this.props.title} />
        <div className='module-inner' ref={el => this.navContainer = el} id='sub-navigation'>
                    {Tabs}
                </div>
    </div>
        )

	    const Mobile = (
            <div className='d-sm-none'>
        <div ref={el => this.navHeaderMobile = el} />
        <div className='heading-wrapper'>
                    <div>
                <h3 className='m-0 mb-2'>Manage my service</h3>
                <p className='m-0 font-xsmall'>{this.props.mobileSubCopy ? this.props.mobileSubCopy : '(click the arrow on the right to view usage, service details, plan change and lots more)'}</p>
            </div>
                    <a href='#' onClick={this.toggleExpand.bind(this)}>
                <img src='/images/icon-arrow-selector.svg' alt='' />
            </a>
                </div>
        <div ref={el => this.hiddenContent = el} className='hidden-content'>
                    {Tabs}
                </div>
        <div id='sub-navigation-mobile' ref={el => this.navContainerMobile = el} />
    </div>
        )

        return (
            <div className={`sub-navigation module ${this.props.className ? this.props.className : ''}`}>
                {Desktop}
                {Mobile}
            </div>
        )
    }
}

SubNavigation.propTypes = {
    title: PropTypes.string,
    items: PropTypes.array,
    url: PropTypes.string,
    className: PropTypes.string,
    mobileSubCopy: PropTypes.string
}

export default SubNavigation



// WEBPACK FOOTER //
// ./resources/js/modules/SubNavigation.js